// extracted by mini-css-extract-plugin
export default {"bandeau":"style_bandeau__058+h","pp":"style_pp__35G6T","pbtn":"style_pbtn__ws785","accepter":"style_accepter__tDQKx","refuser":"style_refuser__xuA-F"};